import { inject } from '@angular/core';
import { createEffect, ofType, Actions } from '@ngrx/effects';
import { of, pipe } from 'rxjs';
import * as actions from '../actions/faq.action';
import { switchMap, map, catchError } from 'rxjs/operators';
import { FaqCategoriesService } from '../../services';

export const LoadFaq$ = createEffect(
  (actions$ = inject(Actions), service = inject(FaqCategoriesService)) => {
    return actions$.pipe(
      ofType(actions.LoadFaq),
      switchMap(() =>
        service.getFaq().pipe(
          map(faq => actions.LoadFaqSuccess({ faq })),
          catchError(error => of(actions.LoadFaqFail({ error })))
        )
      )
    );
  },
  { functional: true }
);
